namespace RioERP.Reports {
    export namespace B2CStatewiseGstReportSummaryService {
        export const baseUrl = 'Reports/B2CStatewiseGstReportSummary';

        export declare function Create(request: Serenity.SaveRequest<B2CStatewiseGstReportSummaryRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<B2CStatewiseGstReportSummaryRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<B2CStatewiseGstReportSummaryRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<B2CStatewiseGstReportSummaryRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Reports/B2CStatewiseGstReportSummary/Create",
            Update = "Reports/B2CStatewiseGstReportSummary/Update",
            Delete = "Reports/B2CStatewiseGstReportSummary/Delete",
            Retrieve = "Reports/B2CStatewiseGstReportSummary/Retrieve",
            List = "Reports/B2CStatewiseGstReportSummary/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>B2CStatewiseGstReportSummaryService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
